import assetAdvancedFilters from '../modals/advancedFilters/lan/en';
import createEditAsset from '../modals/createEditAsset/lan/en';
import deleteAsset from '../modals/deleteAsset/lan/en';
import importAssets from '../modals/importAssets/lan/en';

export default {
    manage_asset_id: "Asset ID",
    manage_asset_unit: "Unit",
    manage_asset_assetType: "Asset Type",
    manage_asset_assetSubType: "Asset Subtype",
    manage_asset_externalID: "External ID",
    manage_asset_make: "Make",
    manage_asset_model: "Model",
    manage_asset_year: "Year",
    manage_asset_engine: "Engine",
    manage_asset_mpg_highway: "MPG Highway",
    manage_asset_mpg_city: "MPG City",
    manage_asset_license_plate: "License Plate",
    manage_asset_vin: "VIN",
    manage_asset_label: "Label",
    manage_asset_inspectionDeviceType: "Inspection Device Type",
    manage_asset_tags: "Tags",
    manage_asset_status: "Status",
    manage_asset_active: "Active",
    manage_asset_inactive: "Inactive",
    manage_asset_search_table: "Search by Label, VIN, Asset Type and Asset Subtype",
    manage_asset_inspectionTagId: "Inspection Tag ID",
    manage_asset_powerUnitNumber: "Power Unit Number",
    manage_asset_maintenanceCompany: "Maintenance Company",
    manage_asset_registrationCountry: "Registration Country",
    manage_asset_registrationState: "Registration State",
    manage_asset_registrationExpiration: "Registration Expiration",
    manage_asset_engineSerialNumber: "Engine Serial Number",
    manage_asset_chassisSerialNumber: "Chassis Serial Number",
    manage_asset_licensePlate: "License Plate",
    ...assetAdvancedFilters,
    ...createEditAsset,
    ...deleteAsset,
    ...importAssets,

}